const cryptocurrencies = [
    {
        "name": "Bitcoin",
        "code": "BTCUSDT",
        "icon": "/icons/btc.svg",
        "icond": "https://cryptologos.cc/logos/bitcoin-btc-logo.png"
    },
    {
        "name": "Ethereum",
        "code": "ETHUSDT",
        "icon": "/icons/eth.svg",
        "icond": "https://cryptologos.cc/logos/ethereum-eth-logo.png"
    },
    {
        "name": "Binance Coin",
        "code": "BNBUSDT",
        "icon": "/icons/bnb.svg",
        "icond": "https://cryptologos.cc/logos/binance-coin-bnb-logo.png"
    },
    {
        "name": "Cardano",
        "code": "ADAUSDT",
        "icon": "/icons/ada.svg",
        "icond": "https://cryptologos.cc/logos/cardano-ada-logo.png"
    },
    {
        "name": "XRP",
        "code": "XRPUSDT",
        "icon": "/icons/xrp.svg",
        "icond": "https://cryptologos.cc/logos/xrp-xrp-logo.png"
    },
    {
        "name": "Polygon",
        "code": "MATICUSDT",
        "icon": "/icons/matic.svg",
        "icond": "https://cryptologos.cc/logos/adx-adx-logo.png"
    },
    {
        "name": "Litecoin",
        "code": "LTCUSDT",
        "icon": "/icons/ltc.svg",
        "icond": "https://cryptologos.cc/logos/litecoin-ltc-logo.png"
    },

    {
        "name": "Polkadot",
        "code": "DOTUSDT",
        "icon": "/icons/dot.svg",
        "icond": "https://cryptologos.cc/logos/polkadot-new-dot-logo.png"
    },
    {
        "name": "Bitcoin Cash",
        "code": "BCHUSDT",
        "icon": "/icons/bch.svg",
        "icond": "https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png"
    },
    {
        "name": "Chainlink",
        "code": "LINKUSDT",
        "icon": "/icons/link.svg",
        "icond": "https://cryptologos.cc/logos/chainlink-link-logo.png"
    },

    {
        "name": "Stellar",
        "code": "XLMUSDT",
        "icon": "/icons/xlm.svg",
        "icond": "https://cryptologos.cc/logos/stellar-xlm-logo.png"
    },
    {
        "name": "Filecoin",
        "code": "FILUSDT",
        "icon": "/icons/fil.svg",
        "icond": "https://cryptologos.cc/logos/filecoin-fil-logo.png"
    },
    {
        "name": "EOS",
        "code": "EOSUSDT",
        "icon": "/icons/eos.svg",
        "icond": "https://cryptologos.cc/logos/eos-eos-logo.png"
    },
    {
        "name": "Aave",
        "code": "AAVEUSDT",
        "icon": "/icons/aave.svg",
        "icond": "https://cryptologos.cc/logos/aave-aave-logo.png"
    },


    {
        "name": "TRON",
        "code": "TRXUSDT",
        "icon": "/icons/trx.svg",
        "icond": "https://cryptologos.cc/logos/tron-trx-logo.png"
    },

    {
        "name": "2GIVE",
        "code": "2GIVEUSDT",
        "icon": "/icons/2give.svg",
        "icond": "https://cryptologos.cc/logos/2give-2give-logo.png"
    },

    {
        "name": "Polymath",
        "code": "POLYUSDT",
        "icon": "/icons/poly.svg",
        "icond": "https://cryptologos.cc/logos/adx-adx-logo.png"
    },
    {
        "name": "Parellel",
        "code": "PRLUSDT",
        "icon": "/icons/prl.svg",
        "icond": "https://cryptologos.cc/logos/adx-adx-logo.png"
    },
    {
        "name": "Dogecoin",
        "code": "DOGUSDTE",
        "icon": "/icons/doge.svg",
        "icond": "https://cryptologos.cc/logos/dogecoin-doge-logo.png"
    },
    {
        "name": "Bitcoin SV",
        "code": "BSVUSDT",
        "icon": "/icons/bsv.svg",
        "icond": "https://cryptologos.cc/logos/bitcoin-sv-bsv-logo.png"
    },
    {
        "name": "Theta Network",
        "code": "THETAUSDT",
        "icon": "/icons/theta.svg",
        "icond": "https://cryptologos.cc/logos/theta-theta-logo.png"
    },
]

export { cryptocurrencies }